<template>
  <template v-if="ShowVet">
    <HomeVet />
  </template>
  <template v-else-if="ShowDelegue">
    <HomeDelegue />
  </template>
  <template v-else>
    <HomeClient />
  </template>
</template>

<script>
import HomeVet from "@/views/supplyvet/HomeVet.vue";
import HomeClient from "@/views/e-supplyvet/HomeClient.vue";
import HomeDelegue from "@/views/DelegueDashboard.vue";
import { useRegisterStore } from "@/stores/register";

export default {
  name: "HomePage",
  components: {
    HomeVet,
    HomeClient,
    HomeDelegue,
  },
  data() {
    return {
      ShowVet: false,
      ShowDelegue: false,
    };
  },
  created() {
    this.registerStore = useRegisterStore();
    if (this.registerStore.user) {
      this.ShowVet = this.registerStore.user.role === "veterinaire";
      this.ShowDelegue = this.registerStore.user.role === "delegues";
    }
  },
};
</script>